import { render, staticRenderFns } from "./sidebar-field-row.vue?vue&type=template&id=353f8541&scoped=true"
import script from "./sidebar-field-row.vue?vue&type=script&lang=js"
export * from "./sidebar-field-row.vue?vue&type=script&lang=js"
import style0 from "./sidebar-field-row.vue?vue&type=style&index=0&id=353f8541&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353f8541",
  null
  
)

export default component.exports